import React, {FC, Suspense, useContext, LazyExoticComponent} from 'react';
import {RouteComponentProps} from '@reach/router';
import {AuthContext} from '@src/Providers/AuthProvider/AuthProvider';
import {pageRequiresAuth} from '@src/Services/AccessControl/accessRules';
// import useAppNavigation from '@src/utils/useAppNavigation';
// import {Routes} from '@src/Constant/routes';

export interface IPrivateRouteProps extends RouteComponentProps {
  component: LazyExoticComponent<FC<RouteComponentProps>>;
}

const PrivateRoute = ({
  component: Component,
  location,
  ...rest
}: IPrivateRouteProps) => {
  const {isLoggedIn, isLoading} = useContext(AuthContext);
  // const navigation = useAppNavigation();

  // ✅ NOUVEAU : Vérifier si la route nécessite vraiment une authentification
  const currentPath = location?.pathname || '';
  const authRequired = pageRequiresAuth(currentPath);

  // Si la route nécessite une authentification ET que l'utilisateur n'est pas connecté
  if (authRequired && !isLoggedIn && !isLoading) {
    console.log(
      '🔒 [PrivateRoute] Accès bloqué pour route protégée:',
      currentPath,
    );
    return null;
  }

  // ✅ Pour toutes les autres routes : accès autorisé même sans connexion
  if (!isLoading) {
    return (
      <Suspense fallback={null}>
        <Component {...rest} />
      </Suspense>
    );
  }

  // En cours de chargement
  return null;
};

export default PrivateRoute;
